var _linkLtik = null;

exports.getLinkLtik = function () {
  return _linkLtik;
};

exports.setLinkLtik = function (linkLtik) {
  _linkLtik = linkLtik;
};
